import script from "./DomainModelDomainEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelDomainEvent.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelDomainEvent.vue?vue&type=style&index=0&id=b6c68872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6c68872"]])

export default __exports__